export enum PlatformType {
  windows = 'Windows',
  mac = 'MacOS',
  linux = 'Linux',
}
